export default function SafetySection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-6 text-center">
          Czy Kakobuy Spreadsheet jest bezpieczny?
        </h2>

        <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              Nasza strona pełni funkcję <strong>informacyjną</strong>. Nie przechowujemy danych płatniczych
              użytkowników. Nie jesteśmy oficjalnym sklepem Kakobuy — jesteśmy niezależnym przewodnikiem,
              który pomaga polskim klientom w bezpiecznym korzystaniu z platform zakupowych.
            </p>
            <p>
              Pokazujemy użytkownikom jak korzystać z platform zakupowych bezpiecznie, na co zwracać uwagę
              przy wyborze sprzedawcy oraz jak interpretować zdjęcia QC. Nasze rekomendacje opierają się
              na rzeczywistych doświadczeniach społeczności zakupowej.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-6 pt-6 border-t border-background-200/70">
              <div className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-lock-line text-accent-500 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-600">Nie przechowujemy danych płatniczych</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-shield-check-line text-accent-500 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-600">Niezależny przewodnik informacyjny</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-user-heart-line text-accent-500 text-sm"></i>
                </span>
                <span className="text-xs md:text-sm text-foreground-600">Rekomendacje oparte na doświadczeniach</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}